import React, { useEffect } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import UserGuide from '../../components/UserGuide';
import { StyledContainer } from './styled';
import { StyledWrapper } from '../styled';
import Seo from '../../components/Seo';
import { USER_GUIDE_SEO } from '../../service/seoMeta';

export default function UserGuideComponent() {
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/user-guide') {
      history.push('/user-guide/start');
    }
  }, [history, location.pathname]);

  const section = location.pathname.replace(/^\/user-guide\/?/, '') || 'start';
  const seoPath = section ? `/user-guide/${section}` : '/user-guide/start';
  const meta = USER_GUIDE_SEO[section] || USER_GUIDE_SEO.start;

  return (
    <StyledWrapper>
      <Seo title={meta.title} description={meta.description} path={seoPath} />
      <StyledContainer>
        <Switch>
          <Route
            path="/user-guide/start"
            render={() => <UserGuide content="start" />}
          />
          <Route
            path="/user-guide/players"
            render={() => <UserGuide content="players" />}
          />
          <Route
            path="/user-guide/off-season"
            render={() => <UserGuide content="off-season" />}
          />
          <Route
            path="/user-guide/trading"
            render={() => <UserGuide content="trading" />}
          />
          <Route
            path="/user-guide/competitions"
            render={() => <UserGuide content="competitions" />}
          />
          <Route
            path="/user-guide/coaching"
            render={() => <UserGuide content="coaching" />}
          />
          <Route
            path="/user-guide/finances"
            render={() => <UserGuide content="finances" />}
          />
        </Switch>
      </StyledContainer>
    </StyledWrapper>
  );
}
